import { moduleTestingPermissions } from "./moduleTestingPermissions";

export function isTestingMode(subresourceName) {
	return moduleTestingPermissions[subresourceName] === true;
}
